import React from 'react'

export default function projectcard(props) {
  return (
    <a href={`${props.plink}`} target="_blank" rel="noopener noreferrer" className='group'>
      <div className='glass-card h-full flex flex-col overflow-hidden hover:scale-105 transition-all duration-300'>
        <div className='absolute -inset-0.5 bg-gradient-to-r from-accent-purple via-accent-cyan to-accent-pink rounded-2xl opacity-0 group-hover:opacity-50 blur transition duration-300'></div>
        
        <div className='relative flex-1 flex flex-col'>
          {/* Image Container */}
          <div className='relative overflow-hidden rounded-xl mb-4 h-48'>
            <img 
              src={props.pimage} 
              className='w-full h-full object-cover group-hover:scale-110 group-hover:brightness-110 transition-all duration-500' 
              alt={props.ptitle} 
            />
            <div className='absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300'></div>
          </div>
          
          {/* Content */}
          <div className='flex-1 flex flex-col'>
            <h2 className='text-2xl font-bold text-white mb-3 group-hover:gradient-text transition-all duration-300'>
              {props.ptitle}
            </h2>
            <p className='text-white/70 text-sm leading-relaxed line-clamp-4'>
              {props.pdesc}
            </p>
          </div>
        </div>
      </div>
    </a>
  )
}
